import axiosClient from "./axiosClient";

export const getPropertyDocuments = async (propertyId) => {
  const response = await axiosClient.get(`/properties/${propertyId}/documents/`);
  return response.data;
};

export const uploadPropertyDocument = async (
  propertyId,
  file,
  { insurancePolicyId, utilityId, assessmentId, unitId } = {}
) => {
  const formData = new FormData();
  formData.append("file", file);
  if (insurancePolicyId) {
    formData.append("insurance_policy_id", insurancePolicyId);
  }
  if (utilityId) {
    formData.append("utility_id", utilityId);
  }
  if (assessmentId) {
    formData.append("assessment_id", assessmentId);
  }
  if (unitId) {
    formData.append("unit_id", unitId);
  }
  const response = await axiosClient.post(
    `/properties/${propertyId}/documents/`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

export const replacePropertyDocument = async (propertyId, documentId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.put(
    `/properties/${propertyId}/documents/${documentId}/`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

export const deletePropertyDocument = async (propertyId, documentId) => {
  const response = await axiosClient.delete(
    `/properties/${propertyId}/documents/${documentId}/`
  );
  return response.data;
};

export const getPropertyDocumentDownload = async (propertyId, documentId) => {
  return axiosClient.get(
    `/properties/${propertyId}/documents/${documentId}/download/`,
    { responseType: "blob" }
  );
};

export const getDocumentsTreeNodes = async (nodeId = "root") => {
  const response = await axiosClient.get("/documents/tree/", {
    params: { node: nodeId },
  });
  return response.data;
};

export const getDocumentsPropertyTreeCurrent = async (propertyId) => {
  const response = await axiosClient.get(
    `/documents/tree/property/${propertyId}/current/`
  );
  return response.data;
};
